export default __webpack_public_path__ + "static/media/mlodz3.86ecd5ab.jpg";